import React, { useState } from 'react';
import { Routes, Route, useNavigate, Navigate } from 'react-router-dom';
import Welcome from './pages/Welcome';
import Login from './pages/Login';
import UserRegister from './pages/UserRegister';
import Register from './pages/Register';
import { Box, Container } from '@mui/material';
import Navigation from './components/Navigation';
import Home from './pages/Home';
import { Nutrition } from './pages/Nutrition';
import Profile from './pages/Profile';
import PrivateRoute from './PrivateRoute';

export default function AppContent() {
  const [navValue, setNavValue] = useState(0);
  const navigate = useNavigate();

  const handleNavChange = (_: React.SyntheticEvent, newValue: number) => {
    setNavValue(newValue);
    switch (newValue) {
      case 0:
        navigate('/');
        break;
      case 1:
        navigate('/register');
        break;
      case 2:
        navigate('/nutrition');
        break;
      case 3:
        navigate('/profile');
        break;
      default:
        navigate('/');
    }
  };

  const user = (() => {
    try {
      return JSON.parse(localStorage.getItem('user') || 'null');
    } catch {
      return null;
    }
  })();

  return (
    <Box sx={{ pb: 7 }}>
      <Container maxWidth="sm" sx={{ pt: 2 }}>
        <Routes>
          <Route path="/" element={user ? <PrivateRoute><Home /></PrivateRoute> : <Welcome />} />
          <Route path="/user-register" element={!user ? <UserRegister /> : <Navigate to="/" />} />
          <Route path="/login" element={!user ? <Login /> : <Navigate to="/" />} />
          <Route path="/register" element={<PrivateRoute><Register /></PrivateRoute>} />
          <Route path="/nutrition" element={<PrivateRoute><Nutrition /></PrivateRoute>} />
          <Route path="/profile" element={<PrivateRoute><Profile /></PrivateRoute>} />
          <Route path="*" element={user ? <PrivateRoute><Home /></PrivateRoute> : <Welcome />} />
        </Routes>
      </Container>
      {user && <Navigation value={navValue} onChange={handleNavChange} />}
    </Box>
  );
} 